// extracted by mini-css-extract-plugin
module.exports = {"page":"_12347"};